import { Card, Form, Button} from "react-bootstrap"
import { useLocalizedStrings } from "../Localization";
import { useRef, useState } from "react";
import { useAPIUpload, usePost } from "../API";
import { toast } from "react-toastify";
import { copyToClipboard } from "../Util";

export default function PublicS3() {

    const L = useLocalizedStrings();
    const fileInput = useRef(null as any);
    const fileInputLabel = useRef(null as any);
    const [s3URL, setS3URL] = useState('')
    const uploadURL = usePost("/document/upload_url")
    const upload = useAPIUpload("/upload");
    
    async function uploadFile(files: File[]) {
        const url = await uploadURL({
            path: files[0].name,
            length: files[0].size,
            publicFile: true
        }); 
        
        let result;
        
        try {
            result = await upload(files as unknown as any[], {}, url.uploadURL, "PUT");
            setS3URL(url.savedPath!)
        } catch (e) {
            console.warn("Error uploading file: ", e);
            toast.error("Error uploading file") 
        }

        if (typeof result === 'string' && url.savedPath) {
            toast("Upload successful")
        if (fileInput.current) { 
            fileInput.current.reset();
            fileInputLabel.current.innerHTML = L.questions.attachment.choose_files;
        }
        } 
    } 

    return(
        <>
        <p>Upload a file to store on S3 and create a publicly accessible URL.</p>
            <div>
                <Form>
                    <div className="row">
                        <div className="col">
                            <Form.Group>
                            <Form.Label>{L.questions.attachment.file_too_big}</Form.Label>
                            <div className="custom-file">
                            <input
                                multiple
                                className="custom-file-input"
                                id={"fileupload"}
                                onChange={async (e) => {
                                    if (e.target.files && e.target.files.length === 0) {
                                        fileInputLabel.current.innerHTML = L.questions.attachment.choose_file;
                                    } else {
                                        if (e.target.files) {
                                        uploadFile(Array.from(e.target.files));
                                        fileInputLabel.current.innerHTML = L.questions.attachment.choose_file;
                                        }
                                    }
                                }}
                                type="file"
                            />
                            <label
                                ref={fileInputLabel}
                                className={"custom-file-label"}
                                htmlFor={"fileupload"}
                            >
                                {L.questions.attachment.choose_file}
                            </label>
                            </div>
                            </Form.Group>
                        </div>
                    </div>
                </Form>
                <div hidden={!s3URL}>
                    <div className="d-flex justify-content-center m-3">
                        <Card style={{ width: '30rem', padding: '2rem', backgroundColor: "lavender" }}>
                            <Card.Title>
                                Public-Access URL:
                            </Card.Title>
                            <Card.Text id='url'>
                                {s3URL}
                            </Card.Text> 
                            <Button variant="primary" onClick={() => {copyToClipboard(s3URL, 'Copied to Clipboard')}}>
                                Copy URL to Clipboard
                            </Button> 
                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
}
